<template>
  <Row
    class="instrument-row"
    :has-interaction="hasInteraction"
    data-testid="instrument-row"
    :chevron="hasChevron"
  >
    <template #top-left>
      <InstrumentName
        :symbol="instrument.symbol"
        :name="instrument.name || instrument.description"
        :has-ellipsis-on-name="hasEllipsis"
        :type="instrumentType"
      />
    </template>
    <template #top-right>
      <div class="instrument-row__container-right">
        <InstrumentPrice
          :price="instrument.lastPrice"
          :percentual="
            instrument.dailyPercentualChange || instrument.dailyPercentageChange
          "
        />
        <WatchListButton
          v-if="showWatchListButton"
          class="instrument-row__watchlist-button"
          :ticker="instrument.symbol"
          :on-watch-list="Boolean(instrument.watchlistItemId)"
          @click="emitWatchlistClick"
        />
      </div>
    </template>
  </Row>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { Row } from '@warrenbrasil/nebraska-web';
import { InstrumentName } from '../InstrumentName';
import { InstrumentPrice } from '../InstrumentPrice';
import { WatchListButton } from '../WatchListButton';

import { Instrument } from '@/modules/trade/services/search';
import { InstrumentWithWatchlist } from '../../services/instruments';

@Component({
  components: {
    InstrumentName,
    InstrumentPrice,
    Row,
    WatchListButton
  }
})
export default class InstrumentRow extends Vue {
  @Prop({ type: Object, required: true })
  readonly instrument!: Instrument | InstrumentWithWatchlist;

  @Prop({ type: Boolean, default: true })
  readonly hasInteraction!: boolean;

  @Prop({ type: Boolean, default: true })
  readonly hasChevron!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly showWatchListButton!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly hasEllipsis!: boolean;

  @Emit('on-watchlist-click')
  emitWatchlistClick() {}

  get instrumentType() {
    return this.instrument.type?.value;
  }
}
</script>

<style lang="less" scoped>
.instrument-row {
  /deep/ .wrapper {
    .container-right {
      flex: none;
      margin-left: @size-spacing-x300;
    }
  }

  &__container-right {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    height: 100%;
    margin-left: @size-spacing-x300;
  }

  &/deep/ .container-right > div {
    height: 100%;
  }

  &__watchlist-button {
    align-self: center;
    margin-left: @size-spacing-x150;
  }
}
</style>
